import React, { useState } from 'react';
import {ArrowDropDown, ArrowDropUp} from '@mui/icons-material';
import { MY_PURCHASED_COLOR, DISABLED_COLOR, SELECTED_COLOR } from "../../../shared/Modals/PurchaseTokenModal/purchaseTokenModal.data";
import { TokenColorDetailsStyles as styles } from './court.tailwind';

const TokenColorDetails = () => {
  const items = [
    { color: SELECTED_COLOR, heading: 'Selected Token' },
    { color: MY_PURCHASED_COLOR, heading: 'My Purchased Token' },
    { color: DISABLED_COLOR, heading: 'Already Purchased' },
  ];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className={styles.outerContainer}>
      {/* For small screens */}
      <div className={styles.smallScreenContainer}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className={styles.button}
        >
          <span className={styles.detailText}>Legend</span>
          {isDropdownOpen ?  <ArrowDropUp /> : <ArrowDropDown />}
        </button>
        {isDropdownOpen && (
          <div className={styles.detailsContainer}>
            {items.map((item, index) => (
              <div key={index} className={styles.detail}>
                <div className={styles.coloredContainer} style={{ backgroundColor: item.color }} />
                <h1 className={styles.detailText}>{item.heading}</h1>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* For larger screens */}
      <div className={styles.largeScreenContainer}>
        {items.map((item, index) => (
          <div key={index} className={styles.detailsContainer}>
            <div className={styles.coloredContainer} style={{ backgroundColor: item.color }} />
            <h1 className={styles.detailText}>{item.heading}</h1>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TokenColorDetails;
